require('./node_modules/angular/angular.min.js');
module.exports = angular;
